import ArrowsArrowLeftSLine from './arrows-arrow-left-s-line.component.js'

export * from './arrows-arrow-left-s-line.component.js'
export default ArrowsArrowLeftSLine

ArrowsArrowLeftSLine.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-arrow-left-s-line': ArrowsArrowLeftSLine
  }
}
